import {useEffect, useRef} from 'react';

export default function useTimeout(callback?: () => void, delay: number = 0) {
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (delay === null) {
      return
    }

    const id = setTimeout(() => savedCallback.current?.(), delay)

    return () => clearTimeout(id)
  }, [delay])
}